const KPOP_MAPPING_API_BASE =
  "https://bunjang-webhook-api.hallyu-manager.com/_api/v1/kpop-mapping";

export type KpopMember = {
  id: number;
  groupId: number;
  name: string;
  koreanName: string;
  stageName: string;
  birthDate: string;
};

export type KpopMembersResponse = KpopMember[];

/**
 * groupName(또는 koreanName)으로 kpop 멤버 목록 조회.
 * GET /_api/v1/kpop-mapping/kpop-members/by-name?groupName=<name>
 *
 * 컬렉션 pill 에서는 PC_ 제거한 표시명을 groupName 으로 전달.
 */
export async function fetchKpopMembers(
  groupName: string,
  signal?: AbortSignal
): Promise<KpopMembersResponse> {
  const trimmed = groupName.trim();
  if (!trimmed) {
    throw new Error("groupName is required");
  }

  const url = new URL(`${KPOP_MAPPING_API_BASE}/kpop-members/by-name`);
  url.searchParams.set("groupName", trimmed);

  console.log("[poca] fetchKpopMembers — request", url.toString());

  const res = await fetch(url.toString(), { method: "GET", signal });

  if (!res.ok) {
    throw new Error(`kpop-members API ${res.status} ${res.statusText}`);
  }

  const data = (await res.json()) as KpopMembersResponse;
  console.log("[poca] fetchKpopMembers — response", { groupName: trimmed, data });
    return data;
}
